import { render } from "./Restaurant.vue?vue&type=template&id=00a60a58&scoped=true"
import script from "./Restaurant.vue?vue&type=script&lang=js"
export * from "./Restaurant.vue?vue&type=script&lang=js"

import "./Restaurant.vue?vue&type=style&index=0&id=00a60a58&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a60a58"]])

export default __exports__